export default __webpack_public_path__ + "static/media/ayo-ogunseinde-UzSPiVmnkAA-unsplash.6a0cdf99.png";